/**
 * Derives the pass/fail flag used to colour a Bonus Expectation Field cell from
 * the backend-computed status. Pass/fail is never derived from actual vs target.
 *
 * By default a `Passed`/`On Track` status colours green (correct for normal
 * targets and qualifiers, where higher is good). When `belowTargetIsGood` is set
 * on the column (e.g. a disqualifier like preventableAccidents, where fewer is
 * good) the mapping is inverted, so a driver who did NOT trip the disqualifier
 * (`Failed`) colours green. Returns undefined when the status is unknown so the
 * cell renders neutral.
 */
const computeExpectationIsPassed = ({
  status,
  belowTargetIsGood,
}: {
  status: 'Passed' | 'Failed' | 'On Track' | undefined;
  belowTargetIsGood?: boolean;
}): boolean | undefined => {
  if (!status) {
    return undefined;
  }

  const passed = status === 'Passed' || status === 'On Track';
  return belowTargetIsGood ? !passed : passed;
};

export default computeExpectationIsPassed;
